import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './routes'
import { AppShell } from './components/AppShell'
import { AuthProvider } from './lib/auth'

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppShell>
          <AppRoutes />
        </AppShell>
      </AuthProvider>
    </BrowserRouter>
  )
}
